import { FeatureBlogPostsBlock } from 'cms-types'
import { FeatureBlogPosts as FeatureBlogPostsUI, LocalizedComponentProps } from 'ui'

import { getGlobalTypography } from '@/cms'
import { mapCMSBlogToBlogPostCard } from '@/helpers/mapCMSBlogs'

export default async function FeatureBlogPosts({
  title,
  linkToBlogText,
  linkToBlogURL,
  posts,
  locale,
}: LocalizedComponentProps<FeatureBlogPostsBlock>) {
  const globalTypography = await getGlobalTypography(locale)

  const mappedBlogPosts = await Promise.all(
    posts.map(blogPost =>
      mapCMSBlogToBlogPostCard(blogPost, globalTypography.blogPostPage.previewLinkTitle, locale),
    ),
  )

  return (
    <FeatureBlogPostsUI
      title={title}
      linkToBlogText={linkToBlogText}
      linkToBlogURL={linkToBlogURL}
      posts={mappedBlogPosts}
    />
  )
}
